var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-border spinner-theme_default",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("\n    Loading...\n  ")])])
}]

export { render, staticRenderFns }